import dayjs from "dayjs";

import Table from "react-bootstrap/Table";

import { Patient } from "@/@types/sintegrada/Patient";
import { getPlaceOfOccurrence } from "@/utils/placesOfOccurrence";

type Props = {
	deadPatients: Patient[];
};

export function DeadPatientsTable({ deadPatients }: Props) {
	return (
		<Table className="text-center">
			<thead>
				<tr>
					<th className="text-start">Data do óbito</th>
					<th className="text-start">Nome do paciente</th>
					<th>Local da ocorrência</th>
					<th>Cid 10</th>
					<th>Data de nascimento</th>
					<th>Gênero</th>
				</tr>
			</thead>
			<tbody>
				{deadPatients.map((deadPatient, index) => (
					<tr key={`dead-patient-table-row-${index}`}>
						<td className="text-start">
							{deadPatient.deaths?.at(0)?.deathDate
								? dayjs(deadPatient.deaths?.at(0)?.deathDate).format(
										"DD/MM/YYYY HH:mm"
								  )
								: "Não informado"}
						</td>
						<td className="text-start">{deadPatient.name}</td>
						<td>
							{deadPatient.deaths?.at(0)?.placeOfOccurrence
								? getPlaceOfOccurrence(deadPatient.deaths.at(0)!.placeOfOccurrence!)
								: "Não informado"}
						</td>
						<td>{deadPatient.deaths?.at(0)?.cidCode ?? "Não informado"}</td>
						<td>
							{deadPatient.birthdate
								? dayjs(deadPatient.birthdate).format("DD/MM/YYYY")
								: "Não informado"}
						</td>
						<td>
							{deadPatient.gender
								? deadPatient.gender === "M"
									? "Masculino"
									: deadPatient.gender === "F"
									? "Feminino"
									: "Outros"
								: "Não informado"}
						</td>
					</tr>
				))}
			</tbody>
		</Table>
	);
}
